module.exports = __webpack_public_path__ + "static/media/supplier-is-not-provider.d0a581d2.svg";